var angular = require('angular');
var _module = angular.module('benoit');
var _ = require('lodash');
var $ = require('jquery');
var states = require('../../../libs/states');

require('./_styles.scss');
require('../../services/mortgage-calculator-store');
require('../../services/lr-touch');
require('../../filters');
require('../percent-ng-model');
require('../money-ng-model');
require('../blur-on-enter');
require('../prequalify-button');

_module.controller('MortgageCalculatorCtrl', [
    '$log',
    '$scope',
    '$element',
    '$mortgageCalculatorStore',

    function MortgageCalculatorCtrl($log, $scope, $element, $mortgageCalculatorStore) {
        $log.debug('MortgageCalculatorCtrl', this);

        var vm = this;
        this.model = {
            loading: true,
            expanded: false,
            state: _.find(states, { abbr: _.get(vm, 'listing.state', '').toUpperCase() }),
            home_price: undefined,
            loan_type: undefined,
            loan_type_options: [
                '30 Year Fixed',
                '15 Year Fixed',
                '5/1 ARM'
            ],
            down_payment: undefined,
            down_payment_percent: .2,
            down_payment_percent_options: [
                .05,
                .1,
                .15,
                .2
            ],
            interest_rate: undefined,
            property_taxes: undefined,
            hoa_dues: undefined,
            hoa_dues_period: undefined,
            hoi: undefined,
            hoi_percentage: undefined,
            hoi_percentage_average: undefined,
            hoi_percentage_average_default: undefined,
            mortgage_insurance: undefined,
            mortgage_insurance_percent: 0.75
        };
        this.events = {
            onDownPaymentChanged: function () {
                updateDownPaymentPercent();
                updateMortgageInsurance();
            },
            onDownPaymentPercentChanged: function (percent) {
                setDownPaymentPercent(percent);
                updateMortgageInsurance();
            },
            onLoanTypeChanged: setInterestRate,
            onHomePriceChanged: updateDownPayment,
            onHomeOwnersInsuranceChanged: updateHomeOwnersInsurancePercent,
            onHomeOwnersInsurancePercentChanged: updateHomeOwnersInsurance,
            onMortgageInsuranceChanged: updateMortgageInsurancePercent,
            onMortgageInsurancePercentChanged: updateMortgageInsurance,
            onResetClicked: reset
        };
        this.services = {
            calculatePrincipalAndInterest: calculatePrincipalAndInterest,
            calculateMonthlyPayment: calculateMonthlyPayment,
            scrollUp: scrollUp
        };

        // $watch
        $scope.$watch(function () { return $mortgageCalculatorStore.loading; }, function (value) {
            if(!value) {
                setInterestRate();
                vm.model.loading = false;
                startWatchingForChanges();
            }
        });

        function startWatchingForChanges() {
            var propsFilter = [
                'down_payment',
                'down_payment_percent',
                'hoa_dues',
                'hoa_dues_period',
                'hoi',
                'hoi_percentage',
                'home_price',
                'interest_rate',
                'loan_type',
                'mortgage_insurance',
                'mortgage_insurance_percent',
                'property_taxes'
            ];

            $scope.$watch(function () { return _.pick(vm.model, propsFilter); }, function (newValue, oldValue) {
                if(oldValue) {
                    var changedProperties = _.reduce(newValue, function (result, value, key) {
                        if(!_.isEqual(value, oldValue[key])) {
                            var tmp = {
                                old: {},
                                new: {}
                            };
                            tmp.old[key] = angular.isDefined(oldValue[key]) ? oldValue[key] : 'undefined';
                            tmp.new[key] = angular.isDefined(value) ? value : 'undefined';

                            result.push(tmp);
                        }

                        return result;
                    }, []);

                    if(changedProperties.length) {
                        // $log.debug('startWatchingForChanges -> onChange -> oldValue', oldValue);
                        // $log.debug('startWatchingForChanges -> onChange -> newValue', newValue);
                        // $log.debug('startWatchingForChanges -> onChange -> properties changed', JSON.stringify(changedProperties, null, 2));

                        var additionalData = {
                            monthly_payment: calculateMonthlyPayment(),
                            principal: vm.model.home_price - vm.model.down_payment
                        };
                        var data = _.merge(newValue, additionalData);

                        Object.keys(data).reduce(function (result, key) {
                            if(!isNaN(data[key])) {
                                data[key] = Math.round(data[key] * 100) / 100;
                            }

                            return data;
                        }, data);

                        vm.onInteraction({ $data: data });
                    }
                }
            }, true);
        }

        // Functions
        function updateDownPaymentPercent() {
            vm.model.down_payment_percent = Math.round(vm.model.down_payment / vm.model.home_price * 100) / 100;
        }

        function setDownPaymentPercent(percent) {
            vm.model.down_payment_percent = percent;
            updateDownPayment();
        }

        function updateDownPayment() {
            vm.model.down_payment = vm.model.home_price * vm.model.down_payment_percent;
        }

        function updateHomeOwnersInsurancePercent() {
            if(vm.model.hoi) {
                vm.model.hoi_percentage = vm.model.hoi * 12 / vm.listing.price * 100;
            } else {
                vm.model.hoi_percentage = 0;
            }
        }

        function updateHomeOwnersInsurance() {
            vm.model.hoi = vm.listing.price * (vm.model.hoi_percentage / 100) / 12;
        }

        function updateMortgageInsurancePercent() {
            var principal = vm.model.home_price - vm.model.down_payment;
            vm.model.mortgage_insurance_percent = vm.model.mortgage_insurance / principal * 12 * 100;
        }

        function updateMortgageInsurance() {
            var principal = vm.model.home_price - vm.model.down_payment;
            vm.model.mortgage_insurance = principal * (vm.model.mortgage_insurance_percent / 100) / 12;
        }

        function calculatePrincipalAndInterest() {
            var principal = vm.model.home_price - vm.model.down_payment;
            var interestRate = vm.model.interest_rate;
            var numPayments = getNumberOfPayments();

            return $mortgageCalculatorStore.calculatePrincipalAndInterestPayment(principal, interestRate, numPayments);
        }

        function calculateMonthlyPayment() {
            var payment = Math.round(calculatePrincipalAndInterest());
            if(vm.model.hoi) payment += Math.round(vm.model.hoi);
            if(vm.model.property_taxes) payment += Math.round(vm.model.property_taxes / 12);
            if(vm.model.hoa_dues) payment += Math.round(vm.model.hoa_dues);
            if(vm.model.down_payment_percent < .2 && vm.model.mortgage_insurance) payment += Math.round(vm.model.mortgage_insurance);

            return payment;
        }

        function getNumberOfPayments() {
            switch (vm.model.loan_type) {
                case '30 Year Fixed':
                    return 30 * 12;

                case '15 Year Fixed':
                    return 15 * 12;

                case '5/1 ARM':
                    return 30 * 12;
            }
        }

        function setInterestRate() {
            switch (vm.model.loan_type) {
                case '30 Year Fixed':
                    vm.model.interest_rate = $mortgageCalculatorStore.interest_rates['30'];
                    break;

                case '15 Year Fixed':
                    vm.model.interest_rate = $mortgageCalculatorStore.interest_rates['15'];
                    break;

                case '5/1 ARM':
                    vm.model.interest_rate = $mortgageCalculatorStore.interest_rates['51'];
                    break;
            }
        }

        function reset() {
            vm.model.home_price = vm.listing.price;
            vm.model.loan_type = vm.model.loan_type_options[0];
            vm.model.down_payment_percent = 0.2;
            vm.model.down_payment = vm.listing.price * vm.model.down_payment_percent;
            vm.model.hoi_percentage = $mortgageCalculatorStore.getHOIRate(vm.listing.state);
            if(vm.model.hoi_percentage) vm.model.hoi = vm.listing.price * (vm.model.hoi_percentage / 100) / 12;

            setInterestRate();

            if(vm.listing.taxes) vm.model.property_taxes = vm.listing.taxes.amount;
            else vm.model.property_taxes = undefined;

            if(vm.listing.hoa_fees) {
                vm.model.hoa_dues = vm.listing.hoa_fees.value;
                vm.model.hoa_dues_period = vm.listing.hoa_fees.currencyPeriod.toLowerCase() === 'monthly' ? 'month' : 'year';
            } else {
                vm.model.hoa_dues = undefined;
                vm.model.hoa_dues_period = undefined;
            }

            vm.model.mortgage_insurance_percent = 0.75;
            updateMortgageInsurance();
        }

        function scrollUp() {
            $('html, body').animate({
                scrollTop: $($element).offset().top - 60
            }, 500);
        }

        function setDefaultValues() {
            vm.model.home_price = vm.listing.price;
            vm.model.loan_type = vm.model.loan_type_options[0];
            vm.model.down_payment = vm.listing.price * vm.model.down_payment_percent;
            vm.model.hoi_percentage = $mortgageCalculatorStore.getHOIRate(vm.listing.state);
            vm.model.hoi_percentage_average = $mortgageCalculatorStore.getHOIRate(vm.listing.state);
            vm.model.hoi_percentage_average_default = $mortgageCalculatorStore.getHOIRate(vm.listing.state);
            if(vm.model.hoi_percentage) vm.model.hoi = vm.listing.price * (vm.model.hoi_percentage / 100) / 12;
            if(vm.listing.taxes) vm.model.property_taxes = vm.listing.taxes.amount;
            if(vm.listing.hoa_fees) {
                vm.model.hoa_dues = vm.listing.hoa_fees.value;
                vm.model.hoa_dues_period = vm.listing.hoa_fees.currencyPeriod.toLowerCase() === 'monthly' ? 'month' : 'year';
            }
            updateMortgageInsurance();
        }

        function init() {
            setDefaultValues();
        }

        // init
        init();
    }
]);

_module.component('mortgageCalculator', {
    template: require('./index.html'),
    controllerAs: 'vm',
    controller: 'MortgageCalculatorCtrl',
    bindings: {
        listing: '<',
        hidePrequalifyButton: '<',
        onInteraction: '&',
        filterId: '@'
    }
});
